import Button from 'chameleon/ui-stack/ui/base/button';
import React from 'react';

const Footer = ({
  onSubmit,
  canSubmit,
  onClose,
  submitBtnText,
  closeBtnText,
}) => {
  const submitButton = (
    <Button
      key="submit-button"
      data-test-id="submit-button"
      isPrimary
      className="ml-4"
      onClick={canSubmit ? onSubmit : () => {}}
      disabled={!canSubmit}
    >
      {submitBtnText}
    </Button>
  );
  const closeButton = (
    <Button
      key="close-button"
      onClick={onClose}
      isNaked
      data-test-id="close-button"
    >
      {closeBtnText}
    </Button>
  );

  return (
    <div className="p-6 self-end">
      {closeButton}
      {submitButton}
    </div>
  );
};

export default Footer;
